import type { ReactNode } from 'react';

import { useMediaQuery } from '@react-hookz/web';
import { useTheme } from 'styled-components';

import { Typography } from 'src/app/components/Elements/Typography';

import { Container, Continue } from './styles';

interface SuccessProps {
  title: ReactNode;
  body: ReactNode;
  /**
   * @todo: Update this to use links later once we have a way to style the button correctly.
   */
  cta: {
    onClick: () => void;
    text: string;
  };
}

export const Success = ({ title, body, cta }: SuccessProps) => {
  const theme = useTheme();
  const isSmallDown = useMediaQuery(theme.breakpoints.smallDown);

  return (
    <Container>
      <Typography variant={isSmallDown ? 'h2' : 'h1'}>{title}</Typography>

      <Typography variant="body">{body}</Typography>

      <Continue style="capsuleBlue50" onClick={cta.onClick}>
        {cta.text}
      </Continue>
    </Container>
  );
};
